
import { ListDataSource } from "@/data/List/ListDataSource";
import { Vue, Component, Watch } from "vue-property-decorator";
import ObjectDataTable from "@/components/helpers/object-data-table.vue";
import {
  mdiDotsVertical,
  mdiFolder,
  mdiFolderOpen,
  mdiMagnify,
  mdiMinus,
  mdiPen,
  mdiPlus,
  mdiPlusCircleOutline,
  mdiTrashCan,
} from "@mdi/js";
import editor from "./editor";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import _ from "lodash";
import axios from "axios";

@Component({
  mixins: [editor],
  components: { ObjectDataTable },
})
export default class ComponentLinkInlineEditor extends Vue {
  //Основаня модель куда линкуются все остальные
  dataSource!: ObjectDataSource;
  searchTimer: any = null;
  dialog: boolean = false;
  searchText: string = "";
  filterText: string = "";
  loaded: boolean = false;
  componentListCopy: any = [];
  icons: any = {
    plus: mdiPlus,
    minus: mdiMinus,
    pen: mdiPen,
    trash: mdiTrashCan,
    search: mdiMagnify,
    dotsVertical: mdiDotsVertical,
    circlePlus: mdiPlusCircleOutline,
    folderOpen: mdiFolderOpen,
    folder: mdiFolder,
  };

  headers: any[] = [
    {
      text: "ID",
      value: "id",
      sortable: true,
    },
    {
      text: "Подпись",
      value: "caption",
      sortable: true,
    },
    {
      text: "Статус",
      value: "instanceStateId",
      sortable: false,
    },
  ];

  public get fieldName() {
    return this.field?.config?.fieldName;
  }
  //К кому линкуем
  public get sourceObjectFieldName() {
    return this.field?.config?.sourceObjectFieldName;
  }

  field!: any;
  //Источник линковки
  targetComponentsDataSource: ListDataSource = new ListDataSource({
    config: { pageIndex: 1, pageSize: 1000 },
    className: this.field?.config?.className,
  });
  //Выбранные компоненты
  linkedComponentsDataSource: ListDataSource = new ListDataSource({
    config: { pageIndex: 1, pageSize: 1000 },
    className: this.field?.config?.className,
  });

  //Связки
  componentLinkDataSource: ListDataSource = new ListDataSource({
    config: { pageIndex: 1, pageSize: 1000 },
    className: this.field?.config?.linkedClassName ?? "ComponentLink",
  });

  $message: any;

  // Поле «Филиалы» в метаданных просит только «филиал компании», а ядро считает
  // связи по двум классам — компании и клиники. На lorlor это 13 филиалов
  // компании и ещё 7 филиалов клиники, которых в списке выбора не было.
  get extraClassNames(): string[] {
    const className = String(this.field?.config?.className ?? "").toLowerCase();
    return className === "companybranch" ? ["clinicBranch"] : [];
  }

  async loadCandidates() {
    await this.targetComponentsDataSource.get();

    for (const className of this.extraClassNames) {
      try {
        const extra = new ListDataSource({
          config: { pageIndex: 1, pageSize: 1000 },
          className,
        });
        await extra.get();
        const known = new Set(this.targetComponentsDataSource.items.map((i: any) => i.id));
        for (const item of extra.items as any[]) {
          if (!known.has(item.id)) this.targetComponentsDataSource.items.push(item);
        }
      } catch (e) {
        // класса может не быть на проекте — остальные кандидаты всё равно покажем
      }
    }
  }

  updateLinkedComponents() {
    let targetComponents = Array.from([...this.targetComponentsDataSource.items]);
    //Удаляем выбранные (жесть)
    for (const target of targetComponents) {
      const exists = this.dataSource.model?.[this.fieldName].some(
        (c: any) => c.id == target.id,
      );
      if (exists) {
        const index = this.targetComponentsDataSource.items.findIndex(
          (c: any) => c.id == target.id,
        );
        this.targetComponentsDataSource.items.splice(index, 1);
      }
    }
    //Вот здесь непонятно что, выбираем выбранные
    this.linkedComponentsDataSource.items = this.dataSource.model?.[this.fieldName]?.map(
      (cf: any) => this.componentListCopy.find((f: any) => f.id == cf.id),
    );
  }

  filterLinkedComponent() {
    this.updateLinkedComponents();
    if (!this.filterText) return;
    const re = new RegExp(this.filterText, "gi");
    this.linkedComponentsDataSource.items =
      this.linkedComponentsDataSource.items.filter((c: any) => c.caption.match(re));
  }

  async created() {

    await this.loadCandidates();
    //Копия списка кандидатов для линкования
    this.componentListCopy = _.cloneDeep(this.targetComponentsDataSource.items);
    this.linkedComponentsDataSource.metadata = this.targetComponentsDataSource.metadata;
    this.linkedComponentsDataSource.total = this.dataSource.model?.[this.fieldName]?.length;
    this.componentLinkDataSource.items = this.dataSource.model?.[this.fieldName];
    this.updateLinkedComponents();
    this.loaded = true;
  }

  async add(item: any) {
    await this.componentLinkDataSource.add({
      [this.sourceObjectFieldName]: this.dataSource.id,
      ComponentId: item.id,
    });

    await this.dataSource.get();
    this.updateLinkedComponents();
    this.linkedComponentsDataSource.total =
      this.linkedComponentsDataSource.items.length;
    this.$message("Успешно добавлено");
  }

  async remove(item: any) {
    const cf = this.dataSource.model?.[this.fieldName]?.find(
      (c: any) => c.id == item.id,
    );

    try {
      await axios.post(`${this.componentLinkDataSource.baseUrl}/delete`, { componentId: item.id, linkedComponentId: this.dataSource.model?.id });
    } catch (error) {
      throw error;
    }
    const index = this.linkedComponentsDataSource.items.findIndex(
      (c: any) => c.id === item.id,
    );
    if (index === -1) throw new Error("не найден");
    this.linkedComponentsDataSource.items.splice(index, 1);
    this.targetComponentsDataSource.items.push(item);
    this.targetComponentsDataSource.items.sort((a, b) => a.id - b.id);
    this.linkedComponentsDataSource.total = this.linkedComponentsDataSource.items.length;

    this.$message("Успешно удалено");
  }

  @Watch("searchText")
  debounceSearch(value: string) {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(async () => {
      this.targetComponentsDataSource.config.filter = JSON.stringify([
        {
          fieldName: "searchText",
          fieldValue: value,
        },
      ]);
      await this.loadCandidates();
      this.updateLinkedComponents();
    }, 1000);
  }
}
